import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

// Themed "download the app" popup for the login/space screen.
export function LoginInstallBanner() {
  const { canInstall, promptInstall, isIOS, isStandalone } = useInstallPrompt();
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (isStandalone) return;
    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, [isStandalone]);

  if (isStandalone || closed || !show) return null;

  const install = async () => {
    const outcome = await promptInstall();
    if (outcome === 'accepted') {
      toast.success('Adding Auralis to your home screen');
      setClosed(true);
    } else if (outcome === 'unavailable') {
      toast.message(
        isIOS ? 'Tap the Share icon, then “Add to Home Screen”' : 'Open your browser menu → “Install app” / “Add to Home Screen”'
      );
    }
  };

  return (
    <div data-testid="login-install-banner" className="fixed right-4 top-4 sm:top-auto sm:bottom-4 z-50 flex items-center gap-1.5 animate-fade-up">
      <button
        data-testid="login-install-btn"
        onClick={install}
        title="Install the Auralis app"
        className="aura-btn-gradient text-white text-sm font-semibold rounded-full p-3 sm:pl-3.5 sm:pr-4 sm:py-2.5 flex items-center gap-2 shadow-lg"
        style={{ boxShadow: '0 10px 26px -8px rgba(124,58,237,0.7)' }}
      >
        <i className="fa-solid fa-download" /> <span className="hidden sm:inline">Install app</span>
      </button>
      <button
        data-testid="login-install-dismiss"
        onClick={() => setClosed(true)}
        title="Dismiss"
        className="grid place-items-center w-8 h-8 rounded-full glass-dark text-white/70 hover:text-white"
      >
        <i className="fa-solid fa-xmark text-xs" />
      </button>
    </div>
  );
}
